import basicSalariesReducer from "./reducers";
export { default as basicSalariesTypes } from "./types";
export { default as basicSalariesOperations } from "./operations";
export default basicSalariesReducer;
